import { RowApplicationVersionDto } from "@/dtos";
import { ApplicationVersion } from "@/entities";

export const formatRowApplicationVersion = (applicationVersions: ApplicationVersion[]) => {
    return applicationVersions.map(x => {
        const row: RowApplicationVersionDto = {
            ...x,
            active: x.is_active ? 'Activo' : 'Inactivo',
            application: x.details.application ?? ''
        }

        return row;
    });
}